var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var e_1, _a;
import { createOverlay, } from '@vfde-brix/ws10/overlay/Overlay';
import { createComponent, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { ACCORDION_BASE_CLASSNAME, createAccordion, } from '@vfde-brix/ws10/accordion';
import { createTooltip, TOOLTIP_BASE_CLASSNAME, } from '@vfde-brix/ws10/tooltip';
import { createTabs, TABS_BASE_CLASSNAME, } from '@vfde-brix/ws10/tabs';
var mountOverlay = function (containerId) {
    var container = document.getElementById(containerId);
    if (!container) {
        container = document.createElement('div');
        container.id = containerId;
        document.body.appendChild(container);
    }
    return createOverlay(container, {
        optPaddingLayout: true,
        business: NO_PATTERN_BUSINESS_LOGIC,
    });
};
var overlay = mountOverlay('ws10-overlay-container');
var overlayTriggers = document.querySelectorAll('a[data-action="ws10-overlay"]:not(.js-overlay-initialized)');
try {
    for (var overlayTriggers_1 = __values(overlayTriggers), overlayTriggers_1_1 = overlayTriggers_1.next(); !overlayTriggers_1_1.done; overlayTriggers_1_1 = overlayTriggers_1.next()) {
        var trigger = overlayTriggers_1_1.value;
        // eslint-disable-next-line @typescript-eslint/no-loop-func
        trigger.addEventListener('click', function (event) { return __awaiter(void 0, void 0, void 0, function () {
            var response, html, parsedDocument, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, fetch(event.currentTarget.href)];
                    case 2:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.text()];
                    case 3:
                        html = _a.sent();
                        parsedDocument = (new DOMParser()).parseFromString(html, 'text/html');
                        initAccordion(parsedDocument);
                        initTooltip(parsedDocument);
                        initTabs(parsedDocument);
                        overlay.injectContent.apply(overlay, __spreadArray([], __read(parsedDocument.getElementsByTagName('body')[0].children), false));
                        overlay.open();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        // eslint-disable-next-line no-console
                        console.error(error_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); });
        trigger.classList.add('js-overlay-initialized');
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (overlayTriggers_1_1 && !overlayTriggers_1_1.done && (_a = overlayTriggers_1.return)) _a.call(overlayTriggers_1);
    }
    finally { if (e_1) throw e_1.error; }
}
var initAccordion = function (doc) {
    var e_2, _a;
    var accordions = doc.getElementsByClassName(ACCORDION_BASE_CLASSNAME);
    try {
        for (var accordions_1 = __values(accordions), accordions_1_1 = accordions_1.next(); !accordions_1_1.done; accordions_1_1 = accordions_1.next()) {
            var accordionElement = accordions_1_1.value;
            createComponent(createAccordion, accordionElement.parentElement, NO_PATTERN_BUSINESS_LOGIC);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (accordions_1_1 && !accordions_1_1.done && (_a = accordions_1.return)) _a.call(accordions_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
};
var initTooltip = function (doc) {
    var e_3, _a;
    var tooltips = doc.getElementsByClassName(TOOLTIP_BASE_CLASSNAME);
    try {
        for (var tooltips_1 = __values(tooltips), tooltips_1_1 = tooltips_1.next(); !tooltips_1_1.done; tooltips_1_1 = tooltips_1.next()) {
            var tooltipElement = tooltips_1_1.value;
            createComponent(createTooltip, tooltipElement.parentElement, NO_PATTERN_BUSINESS_LOGIC);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (tooltips_1_1 && !tooltips_1_1.done && (_a = tooltips_1.return)) _a.call(tooltips_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
};
var initTabs = function (doc) {
    var e_4, _a;
    var tabs = doc.getElementsByClassName(TABS_BASE_CLASSNAME);
    try {
        for (var tabs_1 = __values(tabs), tabs_1_1 = tabs_1.next(); !tabs_1_1.done; tabs_1_1 = tabs_1.next()) {
            var tabElement = tabs_1_1.value;
            createComponent(createTabs, tabElement.parentElement, NO_PATTERN_BUSINESS_LOGIC);
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (tabs_1_1 && !tabs_1_1.done && (_a = tabs_1.return)) _a.call(tabs_1);
        }
        finally { if (e_4) throw e_4.error; }
    }
};
